import styles from "./MobileRequiredScreen.module.scss";

import { Trans, useTranslation } from "react-i18next";

import { AppStoreButton } from "@/modules/shared/components/AppStoreButton";
import { GooglePlayButton } from "@/modules/shared/components/GooglePlayButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";

export function MobileRequiredScreen() {
  const { t } = useTranslation();
  return (
    <PageContainer variant="centered">
      <div className={styles.container}>
        <h1 className={styles.heading}>{t("mobileRequired.title")}</h1>
        <div className={styles.description}>
          <Trans
            i18nKey="mobileRequired.description"
            components={{
              first: <p className={styles.descriptionParagraph} />,
              second: <p className={styles.descriptionParagraph} />,
            }}
          />
        </div>
        <img
          src="/qr.png"
          alt={t("mobileRequired.qrCodeAltText")}
          className={styles.qrCode}
        />
        <div className={styles.buttonContainer}>
          <AppStoreButton />
          <GooglePlayButton />
        </div>
      </div>
    </PageContainer>
  );
}
